import { render, staticRenderFns } from "./Domicilio.vue?vue&type=template&id=24e9daa0&"
import script from "./Domicilio.vue?vue&type=script&lang=js&"
export * from "./Domicilio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports